var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabletLandscape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.4775L18 14.4775V2.47754L2 2.47754L2 14.4775ZM0 15.4775L0 1.47754C0 1.21232 0.105357 0.957968 0.292893 0.770432C0.48043 0.582895 0.734784 0.477539 1 0.477539L19 0.477539C19.2652 0.477539 19.5196 0.582895 19.7071 0.770432C19.8946 0.957968 20 1.21232 20 1.47754V15.4775C20 15.7428 19.8946 15.9971 19.7071 16.1846C19.5196 16.3722 19.2652 16.4775 19 16.4775H1C0.734784 16.4775 0.48043 16.3722 0.292893 16.1846C0.105357 15.9971 0 15.7428 0 15.4775ZM15 8.47754C15 8.21232 15.1054 7.95797 15.2929 7.77043C15.4804 7.5829 15.7348 7.47754 16 7.47754C16.2652 7.47754 16.5196 7.5829 16.7071 7.77043C16.8946 7.95797 17 8.21232 17 8.47754C17 8.74276 16.8946 8.99711 16.7071 9.18465C16.5196 9.37218 16.2652 9.47754 16 9.47754C15.7348 9.47754 15.4804 9.37218 15.2929 9.18465C15.1054 8.99711 15 8.74276 15 8.47754V8.47754Z",
    fill: "#858282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletLandscape);
export default __webpack_public_path__ + "static/media/tablet-landscape.4f5e0b087311dafd39f3c0fa7da3f59a.svg";
export { ForwardRef as ReactComponent };